// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__12EFt","dragIcon":"SortableItem_dragIcon__2-gRW","disabled":"SortableItem_disabled__2UeLh"};